// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3230":"ab973cf0ab38ce11","4527":"c5864aa7d4c21b7f"}[chunkId] + ".css";
};